import React, { useEffect, useState } from "react";
import { Button, Row } from "react-bootstrap";
import Card from "src/components/Cards/Basic";
import FabPlateau from "src/components/UiComponents/Buttons/FabPlateau";
import IconButton from "src/components/IconButton";
import {
  faAdd,
  faPencil as PencilIcon,
  faTrash as DeleteIcon,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useModal from "src/components/Modal/hooks/useModal";
import ConfirmDeleteDialog from "src/components/Modal/ConfirmDelete";
import EditAgeGroupModal from "./EditAgeGroupModal";
import {
  showErrorToast,
  showSuccessToast,
  showValidationErrorToast,
} from "src/components/Toasts";
import axios from "src/config/axios";
import { useTranslation } from "react-i18next";

const AgeGroupSettingsPage = ({}) => {
  function handleEdit(ageGroup) {
    setSelectedAgeGroup(ageGroup);
    toggleEdit();
  }

  function handleArchive(ageGroup) {
    setSelectedAgeGroup(ageGroup);
    toggleArchive();
  }

  function handleCreate() {
    setSelectedAgeGroup({});
    toggleEdit();
  }
  const [ageGroups, setAgeGroups] = useState([]);
  const [selectedAgeGroup, setSelectedAgeGroup] = useState({});
  const { isShow: showEdit, toggle: toggleEdit } = useModal();
  const { isShow: showArchive, toggle: toggleArchive } = useModal();
  const { t } = useTranslation("dashboard");

  useEffect(() => {
    fetchAgeGroups();
  }, []);

  const fetchAgeGroups = () => {
    axios
      .get(`/api/v1/age_groups.json`)
      .then(function (response) {
        setAgeGroups(response.data.entries);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const archive = (ageGroup) => {
    axios
      .delete(`/api/v1/age_groups/${ageGroup.id}.json`)
      .then(function () {
        showSuccessToast();
        fetchAgeGroups();
      })
      .catch(function (error) {
        showValidationErrorToast(error);
      });
  };

  const handleEdited = () => {
    showSuccessToast();
    fetchAgeGroups();
  };

  const handleDelete = () => {
    archive(selectedAgeGroup);
    toggleArchive();
  };

  return (
    <>
      <Card title={`Altersgruppen (${ageGroups.length ?? 0})`}>
        <div className="table-responsive">
          <div className="ui-table-container">
            <table
              className="table table-bordered"
              id="dataTable"
              width="100%"
              cellSpacing="0"
            >
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Von</th>
                  <th>Bis</th>
                  <th>Optionen</th>
                </tr>
              </thead>
              <tbody>
                {ageGroups.map((ageGroup) => {
                  return (
                    <tr key={ageGroup.id}>
                      <td>{ageGroup.name}</td>
                      <td>{ageGroup.from}</td>
                      <td>{ageGroup.to}</td>
                      <td>
                        <IconButton
                          className="mr-1 bg-transparent border-0 mr-3"
                          textColor="var(--primary)"
                          icon={PencilIcon}
                          onClick={() => handleEdit(ageGroup)}
                        />
                        <IconButton
                          className="mr-2 mr-3 bg-transparent border-0"
                          textColor="var(--danger)"
                          icon={DeleteIcon}
                          onClick={() => handleArchive(ageGroup)}
                        />
                      </td>
                    </tr>
                  );
                })}
                {ageGroups.length === 0 && (
                  <tr>
                    <td>{t("common:components.table.noEntries")}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <Row className="justify-content-end mr-2 mt-5">
          <FabPlateau>
            <Button
              className="float-right p-2 pl-3 pr-3"
              variant="primary"
              onClick={handleCreate}
            >
              <FontAwesomeIcon icon={faAdd} />{" "}
              {t("common:components.button.new")}
            </Button>
          </FabPlateau>
        </Row>
      </Card>
      <EditAgeGroupModal
        show={showEdit}
        toggle={toggleEdit}
        ageGroup={selectedAgeGroup}
        handleSuccess={handleEdited}
      />
      <ConfirmDeleteDialog
        show={showArchive}
        handleClose={toggleArchive}
        handleDelete={handleDelete}
      />
    </>
  );
};

export default AgeGroupSettingsPage;
